<template>
	<div>
		<v-row class="mb-5">
			<v-col>
				<p class="text-large">
					The table below provides access to your database of potential participants. You can query, search and sort the available information, perform single or bulk edits, send single or bulk messages, and import further records below.
				</p>
				<v-card class="mx-auto mb-5">      
					<v-toolbar color="black" dark class="mw-h2">
						<v-spacer></v-spacer>
						<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
						></v-text-field>
						<v-dialog v-model="dialogQueryPanelists">
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on">
									<v-icon>mdi-account-question</v-icon>
								</v-btn>
							</template>
							<QueryPanelMembers v-on:complete="completeQuery"></QueryPanelMembers>
						</v-dialog>
					</v-toolbar>
					<v-data-table
					:search="search"
					:headers="headers"
					v-model="selected"
					:items="rows"
					:options="options"
					:show-select="true"
					:selected="selected"
					class="elevation-1"
					>
					<template v-slot:item.role="{item}">
						<span class="text-center">
							<v-icon v-if="item.role == 'panelmember'" color="green">mdi-check-circle</v-icon>
						</span>
					</template>
					<template v-slot:item.tagString="{item}">
						<Tags :inline="true" :saveOnChange=false :panelist="item"></Tags>
					</template>
					<template v-slot:item.status="{item}">
						<span v-if="item.status">{{ prettyPrint( item.status, "TITLE" ) }}</span>
					</template>
					<template v-slot:item.created="{item}">
						<span v-if="item.created">
							{{ item.created.toDate() | moment("D/MM/YYYY HH:mm") }}
						</span>
					</template>
					<template v-slot:item.startDate="{item}">
						<span v-if="item.startDate">
							{{ item.created.toDate() | moment("D/MM/YYYY") }}
						</span>
					</template>
					<template v-slot:item.endDate="{item}">
						<span v-if="item.endDate">
							{{ item.created.toDate() | moment("D/MM/YYYY") }}
						</span>
					</template>
					<template v-slot:item.buttons="{item}">
						<div>
							<Delete :collection="type" :item="item"></Delete>
							<v-btn small class="green ml-2 float-right" dark link :to="{ name:'edit', params: {type: 'panelists', id: item.id }}">Edit</v-btn>
						</div>
					</template>    
					<template v-slot:item.displayName="{item}">
						<v-hover v-slot:default="{ hover }">
							<div>
								{{ item.displayName }}
								<v-btn v-if="hover" icon absolute style="margin-top: -6px" @click="preview(item)"><v-icon>mdi-magnify</v-icon></v-btn>
							</div>
						</v-hover>



					</template>     

					<template v-slot:body.append>
						<tr>
							<td></td>
							<td>
								<v-switch color="green" :value="true" v-model="registeredOnly"></v-switch>
							</td>
						</tr>
					</template>                
				</v-data-table>
				<v-btn absolute dark fab bottom left color="accent"  v-if="!displayNewForm" @click="displayNewForm = true">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<v-btn absolute dark fab bottom left color="warning"  v-if="displayNewForm"  @click="displayNewForm = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card>
			<v-card v-if="displayNewForm" class="mx-auto mb-5">
				<PanelistForm v-on:complete="hideNewForm" role="panelist"></PanelistForm>
			</v-card>
		</v-col>
	</v-row>
	<v-row>
		<v-col >
			<v-btn class="mb-3" v-if="displayImport"  color="red" @click="displayImport = 0" dark>Cancel</v-btn>
			<v-btn class="mb-3" v-if="includeImport && !displayImport"  color="primary" @click="displayImport = 1">Import</v-btn>
			<Import v-if="includeImport && displayImport" v-bind="importProps" v-on:complete="completeImport"></Import>

		</v-col>
	</v-row>
	<v-row>
		<v-col >
			<v-dialog v-model="messagesDialog" :disabled="!selected.length">
				<template v-slot:activator="{ on }">
					<v-btn color="primary" dark v-on="on">
						Send Messages
					</v-btn>
				</template>
				<SendCustomMessage 
				:to="recipients" 
				:anonymous="false" 
				:from="user.uid"
				v-on:cancel="messagesDialog = false"
				v-on:sent="messagesDialog = false"></SendCustomMessage>
			</v-dialog>
			<v-dialog v-model="tagDialog"  :disabled="!selected.length">
				<template v-slot:activator="{ on }">
					<v-btn color="primary" dark v-on="on" class="ml-2">
						Add Tags
					</v-btn>
				</template>
				<v-card>
					<v-card-title class="headline">Add tags</v-card-title>
					<v-card-text>
						Add multiple tags to the selected panelists
						<v-select
						class="body-2"
						v-model="addMultiTags"
						:items="tags"
						:item-text="'displayName'" 
						multiple 
						return-object
						chips
						></v-select>

					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
						color="primary darken-1"
						text
						@click="tagDialog = false"
						>
						Close
					</v-btn>
					<v-btn
					color="green darken-1"
					text
					@click="saveMultiTags"
					>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</v-col>
</v-row>
<v-dialog v-model="previewDialog">
	<v-card class="pa-5">
		<ViewUser :user="previewItem"></ViewUser>
	</v-card>
</v-dialog>

</div>

</template>

<script>
import Vuex from 'vuex';

import {prettyPrint } from "../../assets/utilities.js";
import Delete from "../tools/Delete";
import ViewUser from "../singles/ViewUser.vue"
export default{
	name: "PanelistList",
	props: {},
	components: {
		PanelistForm: () => import('../forms/NewUserForm'),
		Import: () => import("../tools/Import"),
		QueryPanelMembers: () => import("../tools/QueryPanelMembers"),
		Tags: () => import("../tools/Tags"),
		SendCustomMessage: () => import( "../tools/SendCustomMessage" ),
		Delete: Delete,
		ViewUser: ViewUser
	},
	data() {
		return {
			tagDialog: false,
			queryDialog: false,
			addMultiDialog: false, 
			messagesDialog: false,
			previewDialog: false,
			search: '',
			previewItem: null,
			selected: [],
			displayImport: false,
			filteredIds: [],
			otherFilters: {},
			displayNewForm: false,
			addMultiTags: [],
			includeImport: true,
			importCollection: "users",
			registeredOnly: false,
			headers: [
			{  value: "role", text: 'Registered' },
			{  value: "displayName", text: 'Name' },
			{  value: 'status', text: 'Status' },
			{  value: 'email', text: 'Email' },
			{  value: 'phone', text: 'Phone' },
			{  value: 'tagString', text: 'Tags' },
			{  value: 'created', text: 'Created', date: true },
			{  value: 'buttons', text: ' ' }
			],
			options: {
				page: 1,
				itemsPerPage: 5,        
			},
		};
	},
	computed: {
		...Vuex.mapState({
			user: state => state.auth.user,
			view: state => state.auth.view,
			tags: function(state){
				if( !state[state.auth.view] ){ 
					return [] 
				}
				else{
					return state[state.auth.view].tags
				}
			} , 
			items(state){
				var panelists = state[state.auth.view].panelists;
				return panelists;
			}
		}),
		rows(){
			const self = this;
			let items = self.items;
			if( self.filteredIds.length > 0 ){
				items = self.items.filter( i => self.filteredIds.indexOf(i.id) > -1 );
			}
			if( self.registeredOnly ){
				items = items.filter( i => i.role == "panelmember" );
			}
			return items;

		},
		recipients: function(){
			let recipients = [];
			this.selected.forEach( a => {
				recipients.push( a.id )
			})
			return recipients
		},
		importProps(){
			let props = {
				initialFields: ['firstName', 'lastName', 'email', 'phone', 'role'],
				defaults: {publishStatus: "live"},
				fieldFunctions: {
					displayName: function(object){
						return object.firstName + " " + object.lastName;
					} 
				}
					
			}
			return props;
		}
	},
	created: function(){
		const self = this;
		self.$store.dispatch("bindTags" )
		// self.$store.dispatch("fetch", "panelcandidates" )
		// self.$store.dispatch("fetch", "panelmembers" )
		
	},
	watch: {
		type(){
			this.displayNewForm = false;
			this.search = "";
		},
		items(){
			const self = this;
			if( !self.tags ){ return; }
			self.items.forEach( item => {
				if( item.tags ){
					item.tagString = item.tags.map( tagId=>{ 
						let tag = self.tags.find( tag => tag.id == tagId);
						if( tag ){ 
							return tag.displayName 
						} 
					}).join(", ")
				}
				else{
					item.tagString = "";
				}

			})
		}    
	}, 
	methods: {
		prettyPrint: prettyPrint,
		preview(item){
			this.previewItem = item;
			this.previewDialog = true;
		},
		hideNewForm: function(){
			this.displayNewForm = false;
		},
		completeImport(array){
			const self = this;
			array.forEach( panelist => {
				if( !panelist.role || (panelist.role !== 'panelcandidate' && panelist.role !== "panelmember") ){
					panelist.role = "panelcandidate";
				}
				self.$store.dispatch( "addDoc", {
					collection: "users", 
					data: panelist
				})
			})
			this.displayImport = 0;
		},
		saveMultiTags: function(){
			var self = this;
			this.selected.forEach( panelist => {
				let update = false;
				let currentTags = [];
				if( panelist.tags){
					currentTags = panelist.tags;
				}
				self.addMultiTags.forEach( tag => {
					if(currentTags.indexOf( tag.id ) < 0  ){
						currentTags.push( tag.id );
						update = true;
					}
					if( update ){          
						self.$store.dispatch("updateDoc", {
							doc: "users/"+ panelist.id,
							action: "update",
							data: {tags: currentTags}
						}).then(() => self.dialog2 = false)
					}
				})
			})
			self.tagDialog = false;
		},
		completeQuery( results ){
			if( results ){
				this.filteredIds = results;
			}
			this.dialogQueryPanelists = false;
		}
	}
};
</script>